import { AxiosInstance } from 'axios';

import { toResponse } from '../genericToResponse';
import { cancellable } from '../cancellable';

export default (api: AxiosInstance, url: string) => (data: any) => {
  return cancellable<any>(
    (cancelOptions: any) => api.post(url, data, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/linkUpload/createBulkUpload.ts